"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.questionnaireValidator = exports.validateWorkflow = exports.operationsSchema = exports.conditionsSchema = exports.WORKFLOW_VISIBILITY = exports.RATING_TYPE = exports.WORKFLOW_TYPE = exports.QUESTION_TYPE = exports.BEYONOC_CURRENCIES = exports.INTEGRATION_TYPE = exports.FTP_FILE_FORMAT = exports.BEYONIC_WEBHOOKS_EVENT_TYPE = exports.OPERATION_OPERATOR = exports.CONDITION_OPERATOR = void 0;
const joi = __importStar(require("joi"));
const joi_1 = require("joi");
const tools_1 = require("../tools");
var CONDITION_OPERATOR;
(function (CONDITION_OPERATOR) {
    CONDITION_OPERATOR["EQUAL"] = "EQUAL";
    CONDITION_OPERATOR["DIFFERENT"] = "DIFFERENT";
    CONDITION_OPERATOR["GREATER_THAN"] = "GREATER_THAN";
    CONDITION_OPERATOR["LESS_THAN"] = "LESS_THAN";
    CONDITION_OPERATOR["LESS_OR_EQUAL_TO"] = "LESS_OR_EQUAL_TO";
    CONDITION_OPERATOR["GREATER_OR_EQUAL_TO"] = "GREATER_OR_EQUAL_TO";
    CONDITION_OPERATOR["OR"] = "OR";
    CONDITION_OPERATOR["AND"] = "AND";
})(CONDITION_OPERATOR = exports.CONDITION_OPERATOR || (exports.CONDITION_OPERATOR = {}));
var OPERATION_OPERATOR;
(function (OPERATION_OPERATOR) {
    OPERATION_OPERATOR["ADD"] = "ADD";
    OPERATION_OPERATOR["SUBTRACT"] = "SUBTRACT";
    OPERATION_OPERATOR["MULTIPLY"] = "MULTIPLY";
    OPERATION_OPERATOR["DIVIDE"] = "DIVIDE";
})(OPERATION_OPERATOR = exports.OPERATION_OPERATOR || (exports.OPERATION_OPERATOR = {}));
var BEYONIC_WEBHOOKS_EVENT_TYPE;
(function (BEYONIC_WEBHOOKS_EVENT_TYPE) {
    BEYONIC_WEBHOOKS_EVENT_TYPE["PAYMENT_STATUS_CHANGED"] = "payment.status.changed";
    BEYONIC_WEBHOOKS_EVENT_TYPE["COLLECTION_RECEIVED"] = "collection.received";
    BEYONIC_WEBHOOKS_EVENT_TYPE["CONTACT_CREATED"] = "contact.created";
    BEYONIC_WEBHOOKS_EVENT_TYPE["COLLECT_REQUEST_STATUS_CHANGED"] = "collectionrequest.status.changed";
})(BEYONIC_WEBHOOKS_EVENT_TYPE = exports.BEYONIC_WEBHOOKS_EVENT_TYPE || (exports.BEYONIC_WEBHOOKS_EVENT_TYPE = {}));
var FTP_FILE_FORMAT;
(function (FTP_FILE_FORMAT) {
    FTP_FILE_FORMAT["CSV"] = "CSV";
    FTP_FILE_FORMAT["EXCEL"] = "EXCEL";
    FTP_FILE_FORMAT["JSON"] = "JSON";
})(FTP_FILE_FORMAT = exports.FTP_FILE_FORMAT || (exports.FTP_FILE_FORMAT = {}));
var INTEGRATION_TYPE;
(function (INTEGRATION_TYPE) {
    INTEGRATION_TYPE["FRESHDESK"] = "FRESHDESK";
    INTEGRATION_TYPE["BEYONIC"] = "BEYONIC";
    INTEGRATION_TYPE["AFRICASTALKING"] = "AFRICA TALKING";
    INTEGRATION_TYPE["SAP"] = "SAP";
    INTEGRATION_TYPE["FTP"] = "FTP UPLOAD";
})(INTEGRATION_TYPE = exports.INTEGRATION_TYPE || (exports.INTEGRATION_TYPE = {}));
var BEYONOC_CURRENCIES;
(function (BEYONOC_CURRENCIES) {
    BEYONOC_CURRENCIES["BXC"] = "Beyonic Test Currency";
    BEYONOC_CURRENCIES["USD"] = "US Dollars";
    BEYONOC_CURRENCIES["EUR"] = "Euro";
    BEYONOC_CURRENCIES["UGX"] = "Uganda Shillings";
    BEYONOC_CURRENCIES["KES"] = "Kenya Shillings";
    BEYONOC_CURRENCIES["GHS"] = "Ghanaian Cedi";
    BEYONOC_CURRENCIES["TZS"] = "Tanzania Shillings";
    BEYONOC_CURRENCIES["RWF"] = "Rwandan Francs";
    BEYONOC_CURRENCIES["ZMW"] = "Zambian Kwacha";
    BEYONOC_CURRENCIES["MWK"] = "Malawian Kwacha";
    BEYONOC_CURRENCIES["BIF"] = "Burundi Franc";
    BEYONOC_CURRENCIES["XOF"] = "West African CFA franc";
    BEYONOC_CURRENCIES["XAF"] = "Central African CFA Franc";
    BEYONOC_CURRENCIES["GNF"] = "The Guinea franc";
})(BEYONOC_CURRENCIES = exports.BEYONOC_CURRENCIES || (exports.BEYONOC_CURRENCIES = {}));
/**
 * Input type of the answer for a question
 */
var QUESTION_TYPE;
(function (QUESTION_TYPE) {
    QUESTION_TYPE["INTEGER"] = "inputInteger";
    QUESTION_TYPE["DECIMAL"] = "inputDecimal";
    QUESTION_TYPE["MULTIPLE_INPUT_TEXT"] = "multipleInputText";
    QUESTION_TYPE["MULTIPLE_INPUT_INTEGER"] = "multipleInputInteger";
    QUESTION_TYPE["MULTIPLE_INPUT_DECIMAL"] = "multipleInputDecimal";
    QUESTION_TYPE["TEXT"] = "inputText";
    QUESTION_TYPE["PICTURE"] = "picture";
    QUESTION_TYPE["SIGNATURE"] = "signature";
    QUESTION_TYPE["MATRIX_ON_LIST"] = "matrixOnList";
    QUESTION_TYPE["GPS"] = "gps";
    QUESTION_TYPE["BARCODE_SCANNER"] = "barcodeScanner";
    QUESTION_TYPE["TIME_PICKER"] = "timePicker";
    QUESTION_TYPE["DATE_PICKER"] = "datePicker";
    QUESTION_TYPE["PLAIN_TEXT"] = "plainText";
    QUESTION_TYPE["SINGLE_CHOICE_ON_LIST"] = "singleChoiceOnList";
    QUESTION_TYPE["SINGLE_CHOICE"] = "singleChoice";
    QUESTION_TYPE["MULTIPLE_CHOICE"] = "multipleChoice";
    QUESTION_TYPE["MULTIPLE_CHOICE_ON_LIST"] = "multipleChoiceOnList";
    QUESTION_TYPE["MULTIPLE_CHOICE_WITH_NONE"] = "multipleChoiceWithNone";
    QUESTION_TYPE["PHONE_NUMBER"] = "phoneNumber";
    QUESTION_TYPE["COMPUTE"] = "compute";
    QUESTION_TYPE["COMPUTE_ON_MATRIX"] = "computeOnMatrix";
    QUESTION_TYPE["RATING"] = "rating";
    QUESTION_TYPE["UPLOAD_FILE"] = "uploadFile";
    QUESTION_TYPE["OTP_CHECK"] = "OTP_CHECK";
})(QUESTION_TYPE = exports.QUESTION_TYPE || (exports.QUESTION_TYPE = {}));
/**
 * Type of workflow
 */
var WORKFLOW_TYPE;
(function (WORKFLOW_TYPE) {
    WORKFLOW_TYPE["DEFAULT"] = "DEFAULT";
    WORKFLOW_TYPE["TASK"] = "TASK";
    WORKFLOW_TYPE["TASK_GENERATOR"] = "TASK_GENERATOR";
})(WORKFLOW_TYPE = exports.WORKFLOW_TYPE || (exports.WORKFLOW_TYPE = {}));
var RATING_TYPE;
(function (RATING_TYPE) {
    RATING_TYPE["STAR"] = "STAR";
    RATING_TYPE["GENERIC"] = "GENERIC";
})(RATING_TYPE = exports.RATING_TYPE || (exports.RATING_TYPE = {}));
var WORKFLOW_VISIBILITY;
(function (WORKFLOW_VISIBILITY) {
    WORKFLOW_VISIBILITY["WEB_AND_MOBILE"] = "WEB_AND_MOBILE";
    WORKFLOW_VISIBILITY["WEB"] = "WEB";
})(WORKFLOW_VISIBILITY = exports.WORKFLOW_VISIBILITY || (exports.WORKFLOW_VISIBILITY = {}));
exports.conditionsSchema = joi.array().items(joi.object().keys({
    id: joi.number().required(),
    priority: joi.number().required(),
    first: joi.object().keys({
        type: joi.string().required(),
        value: joi.string(),
        tag: joi.string(),
        param: joi.string(),
        attr: joi.string(),
        condition_id: joi.number(),
        cell_attr: joi.string(),
    }),
    second: joi.object().keys({
        type: joi.string().required(),
        value: joi.string(),
        tag: joi.string(),
        param: joi.string(),
        attr: joi.string(),
        condition_id: joi.number(),
        cell_attr: joi.string(),
    }),
    operator: joi
        .string()
        .valid(...Object.values(CONDITION_OPERATOR))
        .required(),
}));
exports.operationsSchema = joi.array().items(joi.object().keys({
    id: joi.number().required(),
    priority: joi.number().required(),
    first: joi.object().keys({
        type: joi.string().required(),
        value: joi.string(),
        tag: joi.string(),
        param: joi.string(),
        attr: joi.string(),
        operation_id: joi.number(),
        cell_attr: joi.string(),
    }),
    second: joi.object().keys({
        type: joi.string().required(),
        value: joi.string(),
        tag: joi.string(),
        param: joi.string(),
        attr: joi.string(),
        operation_id: joi.number(),
        cell_attr: joi.string(),
    }),
    operator: joi
        .string()
        .valid(...Object.values(OPERATION_OPERATOR))
        .required(),
    matrix_question_tag: joi.string(),
    iterate: joi.boolean().strict(),
    iterate_operator: joi.string(),
}));
const validateWorkflow = async (workflow) => {
    const workflowSchema = joi.object().keys({
        id: joi.string().required(),
        version: joi.number(),
        name: joi.string().required(),
        client_id: joi.string().required(),
        client_name: joi.string(),
        questionnaire: joi.any().required(),
        actif: joi.bool(),
        visibility: joi.string().valid(...Object.values(WORKFLOW_VISIBILITY)),
        workflow_type: joi.string(),
        workflow_task_id: joi.string(),
        list_task_id: joi.string(),
        scope: joi.string(),
        task_scope: joi.string(),
        picture_url: joi.string().allow(""),
        is_submission_editable: joi.boolean(),
        edit_submission_offset: joi.number(),
        unique_nplet: joi.array().items(joi.string()),
        nplet_list_id: joi.string(),
        clean_nplet_items_older_than: joi.number(),
        task_list_id: joi.string(),
        task_generator_conditions: exports.conditionsSchema,
        submission_title_template: joi.string(),
        place_list_id: joi.string(),
        is_expiration_date_settable: joi.boolean(),
        link: joi.any(),
        upload_tasks_config: joi.object().keys({
            headers_to_columns: joi.object(),
            internal_submission_id: joi.string(),
            internal_user_id: joi.string(),
        }),
        mobile_user_roles: joi.array().items(joi.string()),
        integrations: joi.array().items(joi.object().keys({
            api_key: joi.string().optional(),
            url: joi.string().optional(),
            type: joi
                .string()
                .valid(...Object.values(INTEGRATION_TYPE))
                .required(),
            index: joi.number(),
            mapping: joi
                .array()
                .items(joi.object().keys({
                index: joi.number(),
                is_custom_field: joi.boolean(),
                should_trigger_update_on_change: joi.boolean().optional(),
                default_value: joi.string().allow(""),
                is_metadata: joi.boolean().optional(),
                destination_variable: joi.string(),
                origin_variable: joi.string(),
                item_attr_name: joi.string().allow(""),
                is_array_field: joi.boolean(),
                sub_fields: joi.array().items(joi.any()),
            }))
                .optional(),
            description: joi_1.string().optional(),
            webhook: joi
                .array()
                .items(joi.object().keys({
                key: joi.string(),
                label: joi.string(),
            }))
                .optional(),
            currency_mapping: joi
                .array()
                .items(joi.object().keys({
                index: joi.number(),
                currency: joi.string().required(),
                account_id: joi.string().required(),
            }))
                .optional(),
            sms_body: joi.string().optional(),
            ftp_file_name: joi.string().optional(),
            ftp_file_format: joi
                .string()
                .valid(...Object.values(FTP_FILE_FORMAT))
                .optional(),
            ftp_file_folder: joi.string().optional(),
            sap_login_endpoint: joi.string().optional(),
            sap_login_company_db: joi.string().optional(),
            sap_login_username: joi.string().optional(),
            sap_login_password: joi.string().optional(),
        })),
    });
    await tools_1.validateJOI(workflowSchema, workflow);
    await exports.questionnaireValidator(workflow.questionnaire);
};
exports.validateWorkflow = validateWorkflow;
const questionnaireValidator = async (questionnaire) => {
    // questions schema
    let questionsSchema = {
        description: joi.string().allow(""),
        deprecated: joi.number(),
        index: joi.number(),
        question_text: joi.string().required(),
        column_type: joi
            .string()
            .valid(...["integer", "float", "decimal", "string", "boolean", "gps", "record"])
            .required(),
        tag: joi.string().lowercase().required(),
        type: joi
            .string()
            .valid(...Object.values(QUESTION_TYPE))
            .required(),
        default_value: joi.string(),
        options: joi
            .array()
            .items(joi.object().keys({
            key: joi.string().required(),
            deprecated: joi.number(),
            value: joi.object().keys({
                type: joi.string().required(),
                value: joi.string().required(),
            }),
        }))
            .allow(null),
        list_id: joi.string().allow(""),
        search_fields: joi.array().items(joi.string()),
        conditions: exports.conditionsSchema,
        operations: exports.operationsSchema,
        is_shareable: joi.boolean(),
        is_manual_input_disabled: joi.boolean(),
        answer_text: joi.string(),
        required: joi.boolean().required(),
        validation: joi.string().allow(""),
        validation_text: joi.string().allow(""),
        number_of_options: joi.number(),
        matrix: joi.object().allow(null),
        category_question_tag: joi.string().allow(""),
        locked: joi.boolean(),
        plus_offset: joi.number(),
        minus_offset: joi.number(),
        team_filter: joi.boolean(),
        hidden: joi.boolean(),
        rating_type: joi.string().valid(...Object.values(RATING_TYPE)),
        rating_max_value: joi.number(),
        rating_step_size: joi.number(),
        restrict_items_by_type: joi.boolean(),
        highlighted: joi.boolean(),
        is_uniq: joi.boolean(),
        recipient_phone_attribute_id: joi.string(),
        similarity_threshold: joi.number(),
        should_check_similarity: joi.boolean(),
    };
    // create the joi schema for a questionnaire
    let schema = joi.object().keys({
        questionnaire_builder_version: joi.string(),
        smala_list_ids: joi.array().items(joi.string()),
        question_groups: joi
            .array()
            .min(1)
            .items(joi.object().keys({
            deprecated: joi.number(),
            title: joi.string().required(),
            index: joi.number(),
            tag: joi.string(),
            questions: joi
                .array()
                .items(joi.object().keys(Object.assign(Object.assign({}, questionsSchema), { matrix: joi
                    .object()
                    .keys({
                    list_id: joi.string(),
                    title_section_attributes: joi.array().items(joi.string()),
                    title_card_attributes: joi.array().items(joi.string()),
                    display_toggle: joi.boolean(),
                    typed_questions: joi
                        .array()
                        .items(Object.assign({}, questionsSchema))
                        .required(),
                    display_all_options: joi.boolean(),
                })
                    .allow(null) })))
                .required(),
        }))
            .required(),
    });
    await tools_1.validateJOI(schema, questionnaire);
    // verify all question group id, question tags and option tags are different
    const mapQuestionTags = {};
    const mapQuestionGroupId = {};
    questionnaire.question_groups.forEach((questionGroup) => {
        if (mapQuestionGroupId[questionGroup.tag]) {
            throw new tools_1.ValidationError(`2 question groups cannot has the same ID. Please retry.`);
        }
        mapQuestionGroupId[questionGroup.tag] = questionGroup.tag;
        questionGroup.questions.forEach((question) => {
            if (mapQuestionTags[question.tag]) {
                throw new tools_1.ValidationError(`Another question already has the tag ${question.tag}.
        You cannot have 2 questions with the same tag! `);
            }
            mapQuestionTags[question.tag] = question.tag;
            const mapOptionKeys = {};
            if (question.options) {
                question.options.forEach((opt) => {
                    if (mapOptionKeys[opt.key]) {
                        throw new tools_1.ValidationError(`Another option already has the key ${opt.key}.
            You cannot have 2 options of the same question with the same key! `);
                    }
                    mapOptionKeys[opt.key] = opt.key;
                });
            }
        });
    });
};
exports.questionnaireValidator = questionnaireValidator;
